module.exports = __webpack_public_path__ + "img/scene_pulse_backlight@2x.6151c7c3.png";